var initialState = {};
var ls = localStorage.getItem("ls");
if(ls && ls !== "undefined") initialState = JSON.parse(ls);

export default function fetchReducer(state, action) {
  state = (typeof state !== 'undefined') ? state : initialState;
  var newState;

  switch (action.type) {
    case "INIT_STATE":
      newState = initState(state, action);
      break;
    case "CLEAR_STATE":
      newState = clearState();
      break;
    case "CLEAR_STATE_BLOCK":
      newState = clearStateBlock(state, action);
      break;
    case "INVALIDATE_STATE_BLOCKS":
      newState = invalidateStateBlocks(state, action);
      break;
    case "REQUEST_DATA":
      newState = requestData(state, action);
      break;
    case "RECEIVE_DATA":
      newState = receiveData(state, action);
      break;
    case "FETCH_ERROR":
      newState = throwError(state, action);
      break;
    case "SET_REDIRECT_URL":
      newState = setRedirectUrl(state, action);
      break;
    case "SET_SESSION_TOKEN":
      newState = setSessionToken(state, action);
      break;
    case "SET_ALERT":
      newState = setAlert(state, action);
      break;
    case "SET_LANGUAGE":
      newState = setLanguage(state, action);
      break;
    case "CLEAR_ALERT":
      newState = clearAlert(state);
      break;
    case "SET_DATA":
      newState = setData(state, action);
      break;
    case "SET_STATE_BLOCK":
      newState = setStateBlock(state, action);
      break;
    default:
      newState = state;
  }

  var lsState = Object.assign({}, newState);
  delete lsState.bin;
  localStorage.setItem("ls", JSON.stringify(lsState));
  return newState;
}

// what does this even do..? pretty sure I copied this from a popular example, but it just overwrites {} and "re"-initializes with current data
function initState(state, action) {
  console.log("initState");
  return Object.assign({}, state);
}

function clearState() {
  localStorage.removeItem("ls");
  return {};
}

function requestData(state, action) {
  var newState = Object.assign({}, state);
  if(newState[action.block] === undefined) {
    newState[action.block] = {isValid: false, isFetching: true, data:[]}
  } else {
    newState[action.block].isValid = false;
    newState[action.block].isFetching = true;
  }
  return newState;
}

function receiveData(state, action) {
  var newState = Object.assign({}, state);
  if(!action.merge_data && !action.merge_partial) {
    newState[action.block] = action.data;
  } else if(action.merge_partial) {
    var partial = action.data.data;
    var block_data = newState[action.block].data;
    // var affected_index = block_data.findIndex(x => x.id === partial.affected_id);
    var affected_index = -1; // deze lijn en items.some waren hier al onderdeel van toen ik de andere projecten aan het mergen was, maar lijkt me niet te werken :)
    items.some(function(x, i) {if(x.id == partial.affected_index) {affected_index = i;return true;}});
    block_data[affected_index][action.merge_partial_key] = (partial.status === "created") ? 1 : 0;
  } else {
    var old_data = newState[action.block].data;
    var new_data = action.data.data;
    newState[action.block] = Object.assign({}, action.data); // this includes message and maybe other (future) keys
    newState[action.block].data = old_data.concat(new_data);
  }
  if(action.pagesize && action.data.data.length < action.pagesize) {
    newState[action.block].limitReached = true;
  }
  if(action.page) newState[action.block].page = action.page;
  if(action.pagesize) newState[action.block].pagesize = action.pagesize;
  newState[action.block].isFetching = false;
  newState[action.block].isValid = true;
  return newState;
}

function throwError(state, action) {
  var newState = Object.assign({}, state);
  if(action.error_type && action.error_type === "success") {
    newState.alert = {"message":action.message, "success":true};
  } else {
    newState[action.block].isFetching = false; // done receiving data
    newState[action.block].isValid = true; // done receiving data
    if(action.error_type && action.error_type === "local") {
      newState.alert = {"message":action.message};
    } else {
      newState.alert = {"status":action.status, "message":action.message, "data":action.data};
    }
  }
  return newState;
}

function setRedirectUrl(state, action) {
  var newState = Object.assign({}, state);
  newState.redirectUrl = action.data;
  return newState;
}

function setSessionToken(state, action) {
  var newState = Object.assign({}, state);
  newState["login"]["data"].token = action.data;
  return newState;
}

function setAlert(state, action) {
  var newState = Object.assign({}, state);
  newState.alert = {"message":action.message, "msgtype":action.msgtype};
  return newState;
}

function setLanguage(state, action) {
  var newState = Object.assign({}, state);
  newState.language = {"language":action.new_language};
  return newState;
}

function clearAlert(state, action) {
  var newState = Object.assign({}, state);
  newState.alert = undefined;
  return newState;
}

function clearStateBlock(state, action) {
  var newState = Object.assign({}, state);
  newState[action.block] = undefined;
  return newState;
}

function invalidateStateBlocks(state, action) {
  var newState = Object.assign({}, state);
  for(var i = 0; i < action.blocks.length; i++) {
    newState[action.blocks[i]].isValid = false;
  }
  return newState;
}

function setData(state, action) {
  var newState = Object.assign({}, state);
  if(newState[action.target_block]) {
    newState[action.target_block].data = Object.assign(newState[action.target_block].data, action.data);
  } else {
    newState[action.target_block] = {};
    if(action.pagesize && action.data.length < action.pagesize) {
      newState[action.target_block].limitReached = true;
    }
    if(action.page) newState[action.target_block].page = action.page;
    if(action.pagesize) newState[action.target_block].pagesize = action.pagesize;
    newState[action.target_block].isFetching = false;
    newState[action.target_block].isValid = true;
    newState[action.target_block].data = action.data;
  }
  return newState;
}

function setStateBlock(state, action) {
  var newState = Object.assign({}, state);
  newState[action.block] = action.data;
  return newState;
}



//////////////////
// WEBPACK FOOTER
// ../_Skelet/src/modules/fetch.reducer.js
// module id = 174
// module chunks = 0